import React from "react";
import { Box, Slide } from "@mui/material";

const AnimatedLogo = ({
  src,
  alt = "Logo",
  height = 36,
  onClick,
  showAnimation = true,
  variant = "default",
}) => {
  const getHeight = () => {
    switch (variant) {
      case "compact":
        return { xs: height * 0.7, sm: height * 0.8 };
      case "large":
        return { xs: height, sm: height * 1.2 };
      default:
        return { xs: height * 0.9, sm: height };
    }
  };

  const logoElement = (
    <Box
      component="img"
      src={src}
      alt={alt}
      sx={{
        height: getHeight(),
        cursor: onClick ? "pointer" : "default",
        transition: "transform 0.3s ease",
        "&:hover": { transform: "scale(1.05)" },
        userSelect: "none",
      }}
      onClick={onClick}
    />
  );

  if (showAnimation) {
    return (
      <Slide direction="down" in={showAnimation} timeout={600}>
        <Box>{logoElement}</Box>
      </Slide>
    );
  }
  return logoElement;
};

export default AnimatedLogo;
